import { render, staticRenderFns } from "./ClubInfo.vue?vue&type=template&id=36a9e1f6&"
import script from "./ClubInfo.vue?vue&type=script&lang=js&"
export * from "./ClubInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports